/*
 * @Author: your name
 * @Date: 2020-05-25 17:37:08
 * @LastEditTime: 2020-06-01 10:37:51
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: /FE-DSTemplate/src/components/MovieCouponContainer/index.js
 */
import React, { Children, isValidElement, cloneElement, PureComponent } from 'react';
import './index.scss';
import api from '@/services/api';
import _ from 'lodash'
export default class MovieCouponContainer extends PureComponent {
  state = {
    couponsData: []
  }

  fetchCoupon = async () => {

    const res = await api.movieDailyCouponService.getMovieDailyCoupons();
    if (res.code !== 0) return;
    // const res = { data: [{ promotionId: '1', status: 1 }, { promotionId: '2', status: 2}, { promotionId: '3', status: 1}]}
    const { data } = res;

    this.setState({ couponsData: data });
  }
  componentDidMount = () => {
    this.fetchCoupon()
  }

  renderCoupon = () => {
    const { children } = this.props;
    const {couponsData} = this.state;
    let renderHtml;
    renderHtml = Children.map(children, (element, i) => {
      return couponsData[i] && isValidElement(element) && cloneElement(element, { refreshPromotionStatus: () => this.fetchCoupon(), ...couponsData[i], key: i })
    })
    return renderHtml
  }
  
  render() {
    const { backgroundBg, style} = this.props
    const {couponsData} = this.state;
   
    return (<div className="movie-coupon-container" style={{ ...style, backgroundImage: `url(${backgroundBg})`, backgroundSize: '100% 100%' }}>
      {!_.isEmpty(couponsData) && this.renderCoupon()}
    </div>)
  }

}
